import { ProcedureTypeFieldsAttachmentService as OvermapProcedureTypeFieldsAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureTypeFieldsAttachmentService extends OvermapProcedureTypeFieldsAttachmentService<
	RootState,
	AppSDK
> {
	host = import.meta.env.REACT_APP_API_URL
}
